angular.module('leanlaw').controller('FixedFeeProfitabilityCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', 'alerts', 'reportsService', 'exportJson', 'singleRequest', 'messageBus', 'userService', function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, reportsService, exportJson, singleRequest, messageBus, userService) {
  $scope.sort = 'client.label';
  $scope.fixedFees = {};
  $scope.filter = {
    ranges: {},
    clientMatter: {},
    selectedUser: {}
  };
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          let exportMatter = {
            'ID': c.client.reference || '',
            'Client': c.client.name,
            [matter]: ''
          };
          exportMatter['Fixed Fees'] = '';
          if ($scope.filter.include && $scope.filter.include.fixedFees) {
            exportMatter['Fixed Fees Date'] = null;
          }
          exportMatter = {
            ...exportMatter,
            'Fixed Fees Charges': $filter('amount')(c.data.amounts.charges),
            'Fixed Fee Hours': $filter('hoursDecimal')(c.data.hours.charges - c.data.hours.additionalCharges),
            'Fixed Fee Hour Value': $filter('amount')(c.data.amounts.chargesHours),
            'Difference': $filter('amount')(c.data.amounts.charges - c.data.amounts.chargesHours)
          };
          exportMatter['Additional Billable Hours'] = $filter('hoursDecimal')(c.data.hours.additionalCharges);
          exportMatter['Additional Billable Amount'] = $filter('amount')(c.data.amounts.additionalCharges);
          accum.push(exportMatter);
        } else {
          let exportClient = {
            'ID': c.client.reference || '',
            'Client': c.client.name
          };
          exportClient['Fixed Fees'] = '';
          if ($scope.filter.include && $scope.filter.include.fixedFees) {
            exportClient['Fixed Fees Date'] = null;
          }
          exportClient = {
            ...exportClient,
            'Fixed Fees Charges': $filter('amount')(c.data.amounts.charges),
            'Fixed Fee Hours': $filter('hoursDecimal')(c.data.hours.charges - c.data.hours.additionalCharges),
            'Fixed Fee Hour Value': $filter('amount')(c.data.amounts.chargesHours),
            'Difference': $filter('amount')(c.data.amounts.charges - c.data.amounts.chargesHours)
          };
          exportClient['Additional Billable Hours'] = $filter('hoursDecimal')(c.data.hours.additionalCharges);
          exportClient['Additional Billable Amount'] = $filter('amount')(c.data.amounts.additionalCharges);
          accum.push(exportClient);
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        let exportMatterWithoutReference = {
          'ID': c.client.reference || '',
          'Client': '',
          [matter]: ''
        };
        exportMatterWithoutReference['Fixed Fees'] = '';
        if ($scope.filter.include && $scope.filter.include.fixedFees) {
          exportMatterWithoutReference['Fixed Fees Date'] = null;
        }
        exportMatterWithoutReference = {
          ...exportMatterWithoutReference,
          'Fixed Fees Charges': $filter('amount')(c.data.amounts.charges),
          'Fixed Fee Hours': $filter('hoursDecimal')(c.data.hours.charges - c.data.hours.additionalCharges),
          'Fixed Fee Hour Value': $filter('amount')(c.data.amounts.chargesHours),
          'Difference': $filter('amount')(c.data.amounts.charges - c.data.amounts.chargesHours)
        };
        exportMatterWithoutReference['Additional Billable Hours'] = $filter('hoursDecimal')(c.data.hours.additionalCharges);
        exportMatterWithoutReference['Additional Billable Amount'] = $filter('amount')(c.data.amounts.additionalCharges);
        accum.push(exportMatterWithoutReference);
      } else {
        let exportClientWithoutReference = {
          'ID': c.client.reference || '',
          'Client': c.client.name
        };
        exportClientWithoutReference['Fixed Fees'] = '';
        if ($scope.filter.include && $scope.filter.include.fixedFees) {
          exportClientWithoutReference['Fixed Fees Date'] = null;
        }
        exportClientWithoutReference = {
          ...exportClientWithoutReference,
          'Fixed Fees Charges': $filter('amount')(c.data.amounts.charges),
          'Fixed Fee Hours': $filter('hoursDecimal')(c.data.hours.charges - c.data.hours.additionalCharges),
          'Fixed Fee Hour Value': $filter('amount')(c.data.amounts.chargesHours),
          'Difference': $filter('amount')(c.data.amounts.charges - c.data.amounts.chargesHours)
        };
        exportClientWithoutReference['Additional Billable Hours'] = $filter('hoursDecimal')(c.data.amounts.hours);
        exportClientWithoutReference['Additional Billable Amount'] = $filter('amount')(c.data.amounts.additionalCharges);
        accum.push(exportClientWithoutReference);
      }
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          let exportIncludesMatter = {
            'ID': m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            'Client': '',
            [matter]: m.matter.label || m.matter.name
          };
          exportIncludesMatter['Fixed Fees'] = '';
          if ($scope.filter.include && $scope.filter.include.fixedFees) {
            exportIncludesMatter['Fixed Fees Date'] = null;
          }
          exportIncludesMatter = {
            ...exportIncludesMatter,
            'Fixed Fees Charges': $filter('amount')(m.data.amounts.charges),
            'Fixed Fee Hours': $filter('hoursDecimal')(m.data.hours.charges - m.data.hours.additionalCharges),
            'Fixed Fee Hour Value': $filter('amount')(m.data.amounts.chargesHours),
            'Difference': $filter('amount')(m.data.amounts.charges - m.data.amounts.chargesHours)
          };
          exportIncludesMatter['Additional Billable Hours'] = $filter('hoursDecimal')(m.data.hours.additionalCharges);
          exportIncludesMatter['Additional Billable Amount'] = $filter('amount')(m.data.amounts.additionalCharges);
          accum.push(exportIncludesMatter);
          if (m.charges && $scope.filter.include.fixedFees) {
            m.charges.forEach(charge => {
              let exportIncludesFixedFees = {
                'ID': '',
                'Client': '',
                [matter]: ''
              };
              exportIncludesFixedFees['Fixed Fees'] = charge.charge.label;
              if ($scope.filter.include && $scope.filter.include.fixedFees) {
                exportIncludesFixedFees['Fixed Fees Date'] = charge.charge.label != "Unassigned" ? charge.charge.date ? $filter('dateLogical')(charge.charge.date) : "Not Complete" : "";
              }
              exportIncludesFixedFees = {
                ...exportIncludesFixedFees,
                'Fixed Fees Charges': $filter('amount')(charge.data.amounts.charges),
                'Fixed Fee Hours': $filter('hoursDecimal')(charge.data.hours.charges - charge.data.hours.additionalCharges),
                'Fixed Fee Hour Value': $filter('amount')(charge.data.amounts.chargesHours),
                'Difference': $filter('amount')(charge.data.amounts.charges - charge.data.amounts.chargesHours)
              };
              exportIncludesFixedFees['Additional Billable Hours'] = $filter('hoursDecimal')(charge.data.hours.additionalCharges);
              exportIncludesFixedFees['Additional Billable Amount'] = $filter('amount')(charge.data.amounts.additionalCharges);
              accum.push(exportIncludesFixedFees);
            });
          }
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };

  ///////////////////////////////////////
  userService.me().then(me => {
    $scope.me = me;
  });
  function calc(data) {
    data.difference = data.amounts.charges - data.hours.nonBillableCost;
  }
  function filterFixedFees(filter) {
    $scope.loading = true;
    filter.secondary = 'charges';
    filter.zerosKey = 'charges';
    var request = angular.copy(filter);
    request.data = 'hours,charges,cost,services';
    request.billingType = 'fixed';
    request.zeros = false;
    request.source = 'fixed-fee-profitability';
    singleRequest.serviceCall('filterFixedFees', reportsService.getClientReport)(request).then(report => {
      if (!report) return;
      report.clients.forEach(client => {
        client.matters.forEach(matter => {
          calc(matter.data);
        });
        calc(client.data);
      });
      calc(report.data);
      $scope.data = report;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel('filterFixedFees');
    deactivate();
  });
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    // if (payload.filter.range) filterClientEntries();
    filterFixedFees($scope.filter);
  });
  $scope.$on('report-sidebar-filterchange', (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);
  });

  // MatterId may be optional
  $scope.goToSummary = function (clientId, matterId) {
    return;
    /**
     * Not removing the code below because it's a good example of how to use the and according to the story things are to be done, It may apply in future
     * https://app.shortcut.com/leanlaw/story/20037/fixed-fee-report-by-user-shows-totals-overall-instead-of-totals-by-the-selected-user
     */

    // console.log("Going to summary", clientId, matterId);
    // $state.go("reports.client-summary", {
    //   clientId,
    //   matterId,
    //   return: "reports.fixed-fee-profitability",
    //   report: `Fixed Fee Profitability`,
    // });
  };

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage('filterDependency-ready', true);

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($scope.data.clients, $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')(client.matters, $scope.sort, $scope.reverse) || [];
      client.filteredMatters.forEach(matter => {
        matter.filteredCharges = $filter('orderBy')(matter.charges, $scope.sort, $scope.reverse) || [];
      });
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);